import React from "react";
import OffersToolsTable from "./OffersToolsTable";

export default function OffersToolsContent() {

    return <div  id="custom-nav-home" role="tabpanel"
                aria-labelledby="custom-nav-home-tab" style={{ height: '80vh'}}>
        <OffersToolsTable/>
    </div>

}